import ReactGA from 'react-ga';

const matchingParams = { debug: false };

/**
 * @desc google analytics event tracking
 * @param {*string} category
 * @param {*string} actionType
 * @param {*string} label
 */
export const triggerEvent = (category, action, label = null, value = 1) => {
  if (typeof window !== 'undefined') {
    ReactGA.event({
      category,
      action,
      label,
      nonInteraction: true,
      value,
    });
  }
};

export const intializeTracker = (key) => {
  if (typeof window !== 'undefined') {
    ReactGA.initialize(key, matchingParams); // zaggleapp8
  }
};

export default { triggerEvent, intializeTracker };



// WEBPACK FOOTER //
// client/devUtils/analytics/googleEventTracking.js